import { BASE_URL } from '../utils';
import { HttpService } from './HttpService';

export const officerServices = () => {
	const { post, put, get } = HttpService();

	const getOfficerData = (type = 'all', pageNumber = 0, pageSize = 25, officerName = '') => {
		const url = `${BASE_URL}/api/officer/${type}?officerName=${officerName}&page=${pageNumber}&size=${pageSize}`;
		return get(url, 'getOfficerData', {});
	};

	const postOfficerData = (body) => {
		const url = `${BASE_URL}/api/officer`;
		return post(url, body, 'createofficer', {});
	};

	const putOfficerData = (officerId, body) => {
		const url = `${BASE_URL}/api/officer/${officerId}`;
		return put(url, body, 'updateofficer', {});
	};

	return { postOfficerData, getOfficerData, putOfficerData };
};
